import React from "react";
import InquiryList from "./InquiryList";
import InquiryDetail from "./InquiryDetail";
import ChatLogList from "./ChatLogList";
import ChatLogDetail from "./ChatLogDetail";
import "./my.css";

// 내 문의 현황 · 내 대화 기록 화면 갈래(주소 #inq · #inq/{id} · #log · #log/{id})
export default function MyPages({ route, go, customer, onChanged, onReask, onResume }) {
    let body = null;
    if (route.view === "inq") {
        body = route.id
            ? <InquiryDetail key={route.id} id={route.id} go={go} customer={customer} onChanged={onChanged} onReask={onReask} />
            : <InquiryList go={go} customer={customer} />;
    } else if (route.view === "log") {
        body = route.id
            ? <ChatLogDetail key={route.id} id={route.id} go={go} customer={customer} onResume={onResume} />
            : <ChatLogList go={go} customer={customer} />;
    }
    return <main className="chatbot-chat-area my-area">{body}</main>;
}
